import { useState} from 'react'
import DeleteProductBadgeModal from '../modals/DeleteProductBadgeModal'

const BadgeProductsTableActionsMenu = ({row: product}: any) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  return [
    {
      label: 'Delete',
      onClick: () => setShowDeleteModal(true),
      render: showDeleteModal && (
        <DeleteProductBadgeModal products={[product]} onClose={() => setShowDeleteModal(false)} />
      ),
    },
  ]
}

export default BadgeProductsTableActionsMenu
